
<div class="modal-dialog nav-tabs-for-header-line" style="max-width: 800px;">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">Workflow Timing Report</h4>
      <button class="close" type="button" (click)="close()">&times;</button>
    </div>
    <div class="modal-body">
      <error [error]="error"></error>
      <div>
        <form [formGroup]="form">
          <div class="row">
            <div class="form-group col-md-6">
              <label for="startDate">Start Date:</label>
              <div class="input-group">
                <input class="form-control" id="startDate" type="text" name="startDate" formControlName="startDate" (change)="txtToDP('startDate')">
                <datepicker class="right input-group-append" id="startDatePicker" formControlName="startDatePicker" name="startDatePicker" (outputEvents)="DPToTxt('startDate')"></datepicker>
              </div>
            </div>
            <div class="form-group col-md-6">
              <label for="endDate">End Date:</label>
              <div class="input-group">
                <input class="form-control" id="endDate" type="text" name="endDate" formControlName="endDate" (change)="txtToDP('endDate')">
                <datepicker class="right input-group-append" id="endDatePicker" formControlName="endDatePicker" name="endDatePicker" (outputEvents)="DPToTxt('endDate')"></datepicker>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="modal-footer">
      <div>
        <h6>Start and End date are relative to UTC</h6>
      </div>
      <button class="btn btn-primary" [disabled]="error" type="button" (click)="createReport()">Create Report</button>
      <button class="btn btn-outline-secondary" type="button" (click)="close()">Cancel</button>
    </div>
  </div>
</div>